// Mantine
import {
    Pagination,
    Button,
    Modal,
    Select,
    Tooltip,
    Anchor,
} from '@mantine/core'

// Icon
import { IconCrystalBall, IconTelescope } from '@tabler/icons-react'

// React
import { useEffect, useState } from 'react'

// UI
import ProfileAvatar from '../ui/ProfileAvatar'

// Dayjs
import dayjs from 'dayjs'

// Next link
import classNames from 'classnames'

export default function ComponentInventoryProjectionEvents({
    inventoryProjectionEvents,
}) {
    // Modale
    const [isOpened, setIsOpened] = useState(false)

    const openModal = () => {
        setIsOpened(true)
    }

    // Projection events
    const verboseEventTypes = {
        purchase_order: 'Bon de commande',
        parent_production_order: 'Utilisé en assemblage',
        production_order: 'Assemblé',
        fulfillment_orders: 'À préparer',
    }

    // Sort events by date
    inventoryProjectionEvents = inventoryProjectionEvents.sort(
        (a, b) => new Date(a.date) - new Date(b.date)
    )

    if (inventoryProjectionEvents.length == 0) {
        return null
    }

    return (
        <>
            <Modal
                opened={isOpened}
                size="xl"
                centered
                title="Projection du stock"
                onClose={() => setIsOpened(false)}
            >
                <div className="flex flex-col border">
                    {inventoryProjectionEvents.map((event, index) => (
                        <div
                            key={index}
                            className="grid grid-cols-[100px_1fr_100px] items-center odd:bg-gray-50 p-5"
                        >
                            <span>
                                {event.quantity > 0 ? (
                                    <span className="text-green-500">
                                        +{event.quantity}
                                    </span>
                                ) : (
                                    <span className="text-red-500">
                                        {event.quantity}
                                    </span>
                                )}
                            </span>

                            <div className="flex flex-col items-start">
                                <span className="text-gray-500">
                                    {verboseEventTypes[event.type]}
                                </span>

                                {event.name && (
                                    <Anchor href={event.href}>
                                        {event.name}
                                    </Anchor>
                                )}
                            </div>

                            <span className="text-gray-600 text-sm">
                                {dayjs(event.date).format('ll')}
                            </span>
                        </div>
                    ))}
                </div>
            </Modal>

            <Tooltip label="Évènements à venir sur ce niveau de stock">
                <Button variant="default" onClick={openModal}>
                    <IconTelescope size={18} />
                </Button>
            </Tooltip>
        </>
    )
}
